export default __webpack_public_path__ + "static/blog-img2-bac9d0052f141d4cc0f11157b80f933a.jpg";